import "./App.css";
import React, { useEffect } from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { fadeInUp } from "@ntg/component-library/utilities";
import { motion } from "motion/react";
import { useLayoutContext } from "@ntg/component-library/contexts";

export default function Home() {
    const { SetPrimaryTitle, SetSecondaryHeader } = useLayoutContext();
        useEffect(() => {
            SetPrimaryTitle("HOME");
            SetSecondaryHeader(null);
            return () => {
                SetPrimaryTitle("");
                SetSecondaryHeader(null);
            };
        }, [SetPrimaryTitle, SetSecondaryHeader]);
    return (
        <>
            <motion.div {...fadeInUp}>
                <Box
                    sx={{
                        alignItems: "center",
                        display: "flex",
                        flexDirection: "row",
                        gap: 7,
                        justifyContent: "left",
                        p: 2
                    }}
                >
                    <Typography
                        sx={{ paddingLeft: "16px" }}
                        variant="body1"
                    >USER MANAGEMENT HOME</Typography>
                </Box>
            </motion.div>
        </>
    );
}